import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { ROUTES } from "@utils/constant";

// For routes that can only be accessed by authenticated users
const AuthGuard = ({ children }) => {
  let epoch = localStorage.getItem("bfs-epoch");
  let date = new Date().getTime() / 1000;

  if (date > epoch) {
    localStorage.clear();
    const returnURL = window?.location?.href?.split("/")?.pop();

    if (window?.location?.pathname !== ROUTES.LOGIN.URL) {
      return (
        <Redirect
          to={{
            pathname: ROUTES.LOGIN.URL,
            state: { paramName: returnURL },
          }}
        />
      );
    }
  }

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
export default AuthGuard;
